import { render, staticRenderFns } from "./CN-M006-01-20.vue?vue&type=template&id=4600d9fa&scoped=true"
import script from "./CN-M006-01-20.vue?vue&type=script&lang=js"
export * from "./CN-M006-01-20.vue?vue&type=script&lang=js"
import style0 from "./CN-M006-01-20.vue?vue&type=style&index=0&id=4600d9fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4600d9fa",
  null
  
)

export default component.exports